import { render, staticRenderFns } from "./SysCategoryList.vue?vue&type=template&id=0d804f7a&scoped=true"
import script from "./SysCategoryList.vue?vue&type=script&lang=js"
export * from "./SysCategoryList.vue?vue&type=script&lang=js"
import style0 from "./SysCategoryList.vue?vue&type=style&index=0&id=0d804f7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d804f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d804f7a')) {
      api.createRecord('0d804f7a', component.options)
    } else {
      api.reload('0d804f7a', component.options)
    }
    module.hot.accept("./SysCategoryList.vue?vue&type=template&id=0d804f7a&scoped=true", function () {
      api.rerender('0d804f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysCategoryList.vue"
export default component.exports